import * as Yup from 'yup';

export const requestResetLinkSchema = () =>
  Yup.object({
    email: Yup.string().email().required(),
  });

export type RequestResetLinkSchemaType = Yup.InferType<
  ReturnType<typeof requestResetLinkSchema>
>;
